import { h } from 'vue';
import { createRouter, createWebHistory, RouteRecordRaw, useRouter, useRoute } from 'vue-router';
import { keyanLogin } from '../services/user';
import { isCustom } from '@/components/customConditionList';
import { getLoginPath } from '@/utils/uri';
import { isNuc } from '@/utils/env';
import { isDzxxwk, isKangeHong, isNf1 } from '@/utils/project';

type LoginComponentType = ()=> Promise<typeof import('*.vue')>

const defaultLogin = () => import(/* webpackChunkName: "Login" */ '../views/Login.vue');
let LoginComponent: LoginComponentType = defaultLogin;
if (isDzxxwk()) {
  LoginComponent = () => import(/* webpackChunkName: "Login" */ '../views/DzxxwkLogin.vue');
}
if (isKangeHong()) {
  LoginComponent = () => import(/* webpackChunkName: "Login" */ '../views/KangeHongLogin.vue');
}
if (isNf1()) {
  LoginComponent = () => import(/* webpackChunkName: "Login" */ '../views/NF1Login.vue');
}



const DynamicHome = (props: {level: number}, context: any) => {
  return h(`h${props.level}`, context.attrs, context.slots);
};
DynamicHome.props = ['level'];
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => h(DynamicHome, {
      level: 4,
      name: '这是未加载到其他页面的显示',
      style: {
        color: '#888999',
        padding: '8px'
      }
    }, '正在载入，请稍后...'),
    beforeEnter(to, from, next) {
      if (to.name === 'Home') {
        keyanLogin().then((res) => {
          if (res.data.success) {
            return next('/project/list');
          }
          return Promise.reject();
        }).catch(() => {
          window.location.replace(getLoginPath());
        });
      }
    }
  },
  {
    path: '/project/list',
    name: 'ProjectList',
    component: () => import(/* webpackChunkName: "ProjectList" */ '../views/Default.vue'),
  },
  {
    path: '/project/CustomNav/:projectId',
    name: 'ProjectCustomNav',
    beforeEnter(to, from, next) {
      // 如果projectId符合定制路由就进入，防止手动输入projectId
      const projectId = +to.params.projectId;
      if (isCustom(projectId)) {
        next();
      } else {
        next('/project/list');
      }
    },
    component: () => import(/* webpackChunkName: "CustomNav" */ '../views/CustomNavPage.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginComponent,
    meta: {
      matchNav: 'Login'
    },
    beforeEnter(to, from, next) {
      if (to.name === 'Login') {
        keyanLogin().then((res) => {
          if (res.data.success) {
            return next('/project/list');
          } else {
            next();
          }
        }, () => {
          if (isNuc && !window.location.search.includes('returnUrl')) {
            window.location.replace(getLoginPath());
          }
          next();
        });
      }
    }
  },
  {
    path: '/service/agreement',
    name: 'ServiceAgreement',
    component: () => import(/* webpackChunkName: "ServiceAgreement" */ '../views/serviceAgreement.vue'),
  },
  {
    path: '/privacy/policy',
    name: 'PrivacyPolicy',
    component: () => import(/* webpackChunkName: "PrivacyPolicy" */ '../views/privacyPolicy.vue'),
  },
  {
    path: '/wechat',
    name: 'Wechat',
    component: () => import(/* webpackChunkName: "Wechat" */ '../views/Wechat.vue'),
  },
  {
    path: '/error/:code',
    name: 'error',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "404error" */ '../views/Error.vue'),
    meta: {
      matchNav: 'error'
    }
  }
  // require('../views/homePage').route
];

const router = createRouter({
  history: createWebHistory(),
  routes
});
const sendToErrorPage = (path: string) => {
  router.push(path);
};
router.afterEach((to) => {
  if (!to.name) sendToErrorPage('/error/404');
});

export default router;
export { useRouter, useRoute };
